<div
  class="brand-filter mat-elevation-z1 atlas"
  [ngClass]="{
    closed: (sidenavOpened$ | async) === false,
    'mat-elevation-z1': brandFiltersService.shouldHaveShadow$ | async,
  }"
  [ngStyle]="{ right: filterBarOffset$ | async }"
  style="display: flex"
>
  <button
    class="icon-filter-button"
    mat-stroked-button
    [matMenuTriggerFor]="filterSelection"
    [matBadge]="filterQuantity$ | async"
    [matBadgeHidden]="(filterQuantity$ | async) === 0"
    matBadgePosition="after"
    matBadgeColor="accent"
  >
    <mat-icon class="icon">filter_list</mat-icon>
    <span class="label">
      {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.FILTERS' | translate }}
    </span>
  </button>
  <mat-menu class="dropdown-menu" [overlapTrigger]="false" #filterSelection="matMenu">
    <button
      mat-menu-item
      (click)="openGeographyDialog()"
      data-action-group="clicked-brand-filter"
      data-action="clicked-brand-filter-open-geography"
    >
      <span>
        {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.TITLES.GEOGRAPHY' | translate }}...
        @if (geographyFilter$ | async) {
          <mat-icon class="filter-indicator">brightness_1</mat-icon>
        }
      </span>
    </button>
    <button
      mat-menu-item
      (click)="openTaxonomyDialog()"
      data-action-group="clicked-brand-filter"
      data-action="clicked-brand-filter-open-taxonomy"
    >
      <span>
        {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.TITLES.CATEGORY' | translate }}...
        @if (busCategoryFilter$ | async) {
          <mat-icon class="filter-indicator">brightness_1</mat-icon>
        }
      </span>
    </button>
    <button
      mat-menu-item
      (click)="openGroupDialog()"
      data-action-group="clicked-brand-filter"
      data-action="clicked-brand-filter-open-group"
    >
      <span>
        {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.TITLES.GROUP' | translate }}...
        @if (groupFilter$ | async) {
          <mat-icon class="filter-indicator">brightness_1</mat-icon>
        }
      </span>
    </button>
    <button
      mat-menu-item
      (click)="openLocationDialog()"
      data-action-group="clicked-brand-filter"
      data-action="clicked-brand-filter-open-location"
    >
      <span>
        {{ 'COMMON.LOCATION' | translate }}...
        @if (locationFilter$ | async) {
          <mat-icon class="filter-indicator">brightness_1</mat-icon>
        }
      </span>
    </button>
    @if (displaySourceFilter()) {
      <button
        mat-menu-item
        (click)="openSourceDialog()"
        data-action-group="clicked-brand-filter"
        data-action="clicked-brand-filter-open-source"
      >
        <span>
          {{ 'COMMON.REVIEW_OR_LISTING_SOURCE' | translate }}...
          @if (sourceFilter$ | async) {
            <mat-icon class="filter-indicator">brightness_1</mat-icon>
          }
        </span>
      </button>
    }
    @if ((filterQuantity$ | async) > 0) {
      <button
        class="clearFilters"
        (click)="clearAllFilters()"
        color="primary"
        mat-menu-item
        data-action-group="clicked-brand-filter"
        data-action="clicked-brand-filter-clear-all"
      >
        {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.CLEAR_ALL_FILTERS' | translate }}
      </button>
    }
  </mat-menu>
</div>
